export default {"src":"/_next/static/media/share-icon-facebook.828afc81.svg","height":26,"width":26};